import React from 'react';
import Select from 'react-select';
import { Plus, Copy, Trash } from 'lucide-react';

export default function RepertoriosStaffSection({
  repertoriosForms,
  contratosList,
  onAddRepertorio,
  onRemoveRepertorio,
  onCopyRequirente,
  onChangeRepertorio
}) {
  return (
    <div style={{ marginBottom: '2rem', padding: '1.5rem', background: '#f8fafc', border: '1px solid #e2e8f0', borderRadius: '8px' }}>
      <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: '1rem' }}>
        <h3 style={{ margin: 0, color: 'var(--primary-dark)' }}>Repertorios Asignados (Opcional - Uso Interno)</h3>
        <button
          type="button"
          onClick={onAddRepertorio}
          className="btn btn-secondary btn-sm"
          style={{ display: 'flex', alignItems: 'center', gap: '6px' }}
        >
          <Plus size={16} /> Agregar Repertorio
        </button>
      </div>

      {repertoriosForms.length === 0 ? (
        <p style={{ color: 'var(--text-muted)', fontSize: '0.9rem', fontStyle: 'italic' }}>
          Puede ingresar el trámite sin repertorios y asignarlos más adelante.
        </p>
      ) : (
        <div style={{ display: 'flex', flexDirection: 'column', gap: '1rem' }}>
          {repertoriosForms.map((f, i) => (
            <div key={i} style={{ padding: '1rem', background: 'white', border: '1px solid #cbd5e1', borderRadius: '6px', position: 'relative' }}>
              <div style={{ position: 'absolute', top: '10px', right: '10px', display: 'flex', gap: '6px' }}>
                {i > 0 && (
                  <button
                    type="button"
                    onClick={() => onCopyRequirente(i)}
                    className="icon-btn"
                    title="Copiar Datos del Primero"
                    style={{ background: '#e0e7ff', color: '#4338ca', padding: '4px' }}
                  >
                    <Copy size={14} />
                  </button>
                )}
                <button
                  type="button"
                  onClick={() => onRemoveRepertorio(i)}
                  className="icon-btn"
                  style={{ background: '#fee2e2', color: '#b91c1c', padding: '4px' }}
                >
                  <Trash size={14} />
                </button>
              </div>
              <h4 style={{ margin: '0 0 0.5rem 0', fontSize: '0.9rem', color: '#475569' }}>Repertorio #{i + 1}</h4>

              <div style={{ display: 'grid', gridTemplateColumns: 'repeat(auto-fit, minmax(200px, 1fr))', gap: '1rem' }}>
                <div>
                  <label style={{ fontSize: '0.8rem', fontWeight: 600 }}>N° Repertorio</label>
                  <input
                    type="text"
                    value={f.numero_repertorio}
                    onChange={e => onChangeRepertorio(i, 'numero_repertorio', e.target.value)}
                    required
                  />
                </div>
                <div>
                  <label style={{ fontSize: '0.8rem', fontWeight: 600 }}>Fecha y Hora</label>
                  <div style={{ display: 'flex', gap: '5px' }}>
                    <input
                      type="date"
                      className="form-control"
                      required
                      value={f.fecha_repertorio ? f.fecha_repertorio.split('T')[0] : ''}
                      onChange={(e) => {
                        const t = f.fecha_repertorio && f.fecha_repertorio.includes('T') ? f.fecha_repertorio.split('T')[1] : '12:00';
                        onChangeRepertorio(i, 'fecha_repertorio', `${e.target.value}T${t}`);
                      }}
                    />
                    <input
                      type="text"
                      className="form-control"
                      required
                      placeholder="HH:mm"
                      maxLength={5}
                      style={{ width: '80px', textAlign: 'center' }}
                      value={f.fecha_repertorio && f.fecha_repertorio.includes('T') ? f.fecha_repertorio.split('T')[1].substring(0, 5) : ''}
                      onChange={e => {
                        let val = e.target.value.replace(/[^0-9]/g, '');
                        if (val.length > 2) val = val.substring(0, 2) + ':' + val.substring(2, 4);
                        const d = f.fecha_repertorio && f.fecha_repertorio.includes('T') ? f.fecha_repertorio.split('T')[0] : new Date().toISOString().split('T')[0];
                        onChangeRepertorio(i, 'fecha_repertorio', `${d}T${val}`);
                      }}
                    />
                  </div>
                </div>
                <div>
                  <label style={{ fontSize: '0.8rem', fontWeight: 600 }}>Nombre Requirente</label>
                  <input
                    type="text"
                    value={f.nombre_requirente}
                    onChange={e => onChangeRepertorio(i, 'nombre_requirente', e.target.value)}
                    required
                  />
                </div>
                <div style={{ flex: '1 1 200px' }}>
                  <label style={{ fontSize: '0.8rem', fontWeight: 600 }}>Contrato / Naturaleza</label>
                  <Select
                    options={contratosList.map(c => ({ value: c.id, label: c.nombre }))}
                    value={f.contrato_id ? { value: f.contrato_id, label: contratosList.find(c => c.id == f.contrato_id)?.nombre } : null}
                    onChange={selected => onChangeRepertorio(i, 'contrato_id', selected ? selected.value : '')}
                    placeholder="Seleccione busque..."
                    isClearable
                    isSearchable
                    closeMenuOnScroll={true}
                    styles={{
                      control: (base) => ({
                        ...base,
                        minHeight: '38px',
                        borderRadius: '0.375rem',
                        borderColor: 'var(--border-color, #cbd5e1)',
                        boxShadow: 'none',
                        '&:hover': { borderColor: 'var(--primary)' }
                      })
                    }}
                  />
                </div>
                {contratosList.find(c => c.id == f.contrato_id)?.nombre === 'Otro' && (
                  <div style={{ gridColumn: 'span 2' }}>
                    <label style={{ fontSize: '0.8rem', fontWeight: 600 }}>Especifique Contrato</label>
                    <input
                      type="text"
                      value={f.contrato_otro}
                      onChange={e => onChangeRepertorio(i, 'contrato_otro', e.target.value)}
                      required
                    />
                  </div>
                )}
              </div>
            </div>
          ))}
        </div>
      )}
    </div>
  );
}
